import { createAction } from "@reduxjs/toolkit";
import {
  ADD_DISCOVERY_PAGES,
  ADD_MY_BILL_DISCOVERY,
  ADD_VISITED_PAGE_DISCOVERY,
  AddDiscoveryMyBillActionType,
  AddDiscoveryPagesActionType,
  addDiscoveryVisitedPageType,
  DELETE_MY_BILL_DISCOVERY,
  deleteDiscoveryMyBillActionType,
  RESET_MY_BILL_DISCOVERY,
} from "./types";

export const addDiscoveryPages = createAction<AddDiscoveryPagesActionType["payload"]>(ADD_DISCOVERY_PAGES);
export const addDiscoveryMyBills = createAction<AddDiscoveryMyBillActionType["payload"]>(ADD_MY_BILL_DISCOVERY);
export const resetDiscoveryMyBills = createAction<any>(RESET_MY_BILL_DISCOVERY);
export const deleteDiscoveryMyBills = createAction<deleteDiscoveryMyBillActionType["payload"]>(DELETE_MY_BILL_DISCOVERY);
export const addVisitedPageDiscovery = createAction<addDiscoveryVisitedPageType["payload"]>(ADD_VISITED_PAGE_DISCOVERY);
